export default {"src":"/_next/static/media/sosbread-white-logo.9c358e40.svg","height":51,"width":164,"blurWidth":0,"blurHeight":0};